export default {
  name: 'stars-rating',

  props: {
    feedbackCanSendFeedbackMessage: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      value: 3,
      tempValue: null,
      ratings: [1, 2, 3, 4, 5],
      message: '',
    };
  },

  computed: {
    messageLength() {
      return this.message.length;
    },
  },

  methods: {
    starOver(rating) {
      this.tempValue = this.value;
      this.value = rating;
    },
    starOut() {
      this.value = this.tempValue;
    },
    setRating(rating) {
      this.tempValue = rating;
      this.value = rating;
      this.$root.$emit('setFeedbak', { rating, message: this.message });
    },
    validateMessageLength() {
      if (this.messageLength >= 255) {
        this.message = this.message.substr(0, 255);
      }
      this.$root.$emit('setFeedbak', { rating: this.value, message: this.message });
    },
  },
};
